import { ExpandButton } from 'mol-ui';
import { config } from 'config';
import parseStatus from 'shared/utils/parseStatus';
import { professionalActions } from 'core/Professional';
import { useHistory } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import {
    ButtonDiv,
    Content
} from './styled';
import {
    ListingItem,
    ListingLayout
} from 'views/components';
import React, { useEffect } from 'react';
import {
    isLocked,
    isSuperadmin
} from 'shared/utils';
import {
    useDispatch,
    useSelector
} from 'hooks';
const {
    doctorsRelated,
    platformPayment,
    professionalStatus
} = config;

const ProfessionalListing = () => {

    const dispatch = useDispatch();
    const { push } = useHistory();
    const { t } = useTranslation();
    const { dangerColor, listingProfessional } = useTheme();

    const headers = [{
        key: 'id',
        label: t('Identificador')
    }, {
        key: 'last_name',
        label: t('Apellido')
    }, {
        key: 'first_name',
        label: t('Nombre')
    }, {
        key: 'identification',
        label: t('DNI')
    }, {
        key: 'specialties',
        label: t('Especialidad')
    }, {
        key: 'attention',
        label: t('Tipo de atención')
    }, {
        key: 'birth_date',
        label: t('Fecha de Nac.')
    }, {
        key: 'cellphone_number',
        label: t('Teléfono')
    }, {
        key: 'email',
        label: t('Mail')
    }, {
        key: 'call_rate',
        label: t('Precio')
    }, {
        key: 'created_at',
        label: t('Fecha de Alta')
    }, {
        key: 'province',
        label: t('Provincia')
    }, {
        key: 'city',
        label: t('Ciudad')
    }, {
        key: 'district',
        label: t('Barrio')
    }, {
        hidden: !platformPayment,
        key: 'expiration_date',
        label: t('Vencimiento')
    }, {
        hidden: !doctorsRelated,
        key: 'total_related_patients',
        label: t('Pacientes vinculados')
    }].filter(({ hidden }) => !hidden);

    const {
        user,
        user: { email }
    } = useSelector('account');
    const {
        busy: professionalBusy,
        list: professionalsList,
        loading
    } = useSelector('professional');

    useEffect(() => {
        dispatch(professionalActions.getProfessionalListing());
    }, []);

    const handleActiveChange = (doctor_id, enabled) => dispatch(professionalActions.professionalSetEnabled({ doctor_id, enabled: !!enabled ? 1 : 0 }));

    const handleFilter = filter => dispatch(professionalActions.getProfessionalListing(filter));

    const handleNewProfessional = () => {
        dispatch(professionalActions.setProfessionalSelected({}));
        push(t('/profesionales/crear'));
    };

    const handleSelection = id => mode => {
        dispatch(professionalActions.setProfessionalSelected({}));
        push(`${ t('/profesionales') }/${ mode }/${ id }`);
    };

    const allowProfessionalCreate = !isLocked(user, 'professionals_create');

    const allowProfessionalEdit = !isLocked(user, 'professionals_edit');

    return (
        <ListingLayout
            downloadData={ professionalsList }
            downloadHeaders={ headers }
            externalLogin={ isSuperadmin(email) }
            filterOptions={ [
                {
                    label: t('Todos'),
                    value: ''
                },
                {
                    label: t('Disponible'),
                    value: 'Available'
                },
                {
                    label: t('En sesión'),
                    value: 'Busy'
                },
                {
                    label: t('No Disponible'),
                    value: 'Unavailable'
                }
            ] }
            loading={ loading }
            onFilterChange={ handleFilter }>
            <Content fullHeight={ !allowProfessionalCreate }>
                { professionalsList ?
                    professionalsList.map(({
                        avatar_thumbnail,
                        enabled,
                        expiration_date,
                        expired,
                        external,
                        first_name,
                        id,
                        last_name,
                        external_reference,
                        specialties,
                        status
                    }) => (
                        <ListingItem
                            active={ !!enabled }
                            activeDisabled={ professionalBusy }
                            allowEdit={ !!allowProfessionalEdit }
                            avatar={ avatar_thumbnail?.url }
                            color={ listingProfessional }
                            icon="face"
                            key={ id }
                            reference={ `
                                ${ !!external_reference ? external_reference : '' }
                                ${ (platformPayment && !!expiration_date) ? `${ t('Vto') }. ${ expiration_date }` : '' }
                            ` }
                            showActive={ true }
                            status={ !professionalStatus ? undefined : parseStatus(status) }
                            text={ specialties }
                            title={ `${ last_name }, ${ first_name } ${ external ?  `(${ t('Externo') })` : '' }` }
                            titleColor={ !!expired ? dangerColor : undefined }
                            onActionClick={ handleSelection(id) }
                            onActiveChange={ () => handleActiveChange(id, !enabled) }
                        />
                    )) : <div>{ t('No hay profesionales para mostrar') }...</div> }
            </Content>
            {
                allowProfessionalCreate &&
                <ButtonDiv>
                    <ExpandButton
                        caption={ t('Nuevo profesional') }
                        size={ 120 }
                        onClick={ handleNewProfessional }
                    />
                </ButtonDiv>
            }
        </ListingLayout>
    );

};

ProfessionalListing.propTypes = {

};

export default ProfessionalListing;
